import React, { useState } from 'react';
import {
  FiShare2, FiMessageCircle, FiMenu, FiArrowLeft, FiTruck, FiDollarSign, FiPhone, FiGlobe,
} from 'react-icons/fi';
import { FaMapMarker } from 'react-icons/fa';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Image, ShareButtons } from '../../../components';
import { setSidebarVisible } from '../../../../support/store/SidebarReducer';
import './styles.css';

const useHeader = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { nickname } = useParams();
  const [shareDisplay, setShareDisplay] = useState(false);
  const [biosOpened, setBiosOpened] = useState(false);

  const handleMenuClick = () => {
    dispatch(setSidebarVisible({ visible: true }));
  };

  const handleRegionClick = (latlng) => {
    const latlngPath = (latlng?.lat && latlng?.lng) ? `@${latlng.lat},${latlng.lng}` :'';
    history.push({
      pathname: `/map/${latlngPath}`,
      state: { previousPath: location.pathname },
    });
  };

  const handleShareClick = () => { setShareDisplay(!shareDisplay); };

  const handleMessageClick = (space) => {
    const message = `Olá, ${space.name}. Gostaria de conversar com você a respeito de algumas de suas ofertas.`;
    window.open(`https://api.whatsapp.com/send?phone=${space.whatsapp}&text=%20${message}`);
  };

  const handleBiosToggle = () => setBiosOpened(!biosOpened);

  const handleBackClick = () => history.goBack();

  return {
    localStates: {
      nickname,
      shareDisplay,
      biosOpened,
    },
    eventsHandlers: {
      handleMenuClick,
      handleRegionClick,
      handleShareClick,
      handleMessageClick,
      handleBiosToggle,
      handleBackClick,
    },
  };
};

export default function Header(props) {
  const {
    sharedStates,
    remoteStates: {
      space,
      users,
    },
    commands,
  } = props;

  const {
    localStates,
    eventsHandlers,
  } = useHeader();
  
  const BIOS_MAX_LEN = 60;
  const ADDR_MAX_LEN = 18;

  const bios = space?.bio
    || 'Seja bem-vinda(o) ao nosso espaço!';
  const daysPT = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

  const usersWithImages = users && users.filter(user=>user.imagesPaths.length);

  return (
    <div className="header-container">
      <section className="navigation-container">
        <FiArrowLeft onClick={eventsHandlers.handleBackClick} color="#000" size={32} style={{ cursor: 'pointer' }} />
        <h2>{`@${space?.nickname ?? 'carregando...'}`}</h2>
        <FiMenu onClick={eventsHandlers.handleMenuClick} color="#000" size={32} style={{ cursor: 'pointer' }} />

        {space?.status === 'inactive'
          && (
            <div className="inactive-indicator">
              Temporariamente inativo
            </div>
          )}
      </section>

      <section className="space-container">
        <div className="space-banner">
          <div className="images-container">
            <div className="space-image" style={{zIndex: users?.length || 0}}>
              <Image
                src={space?.imagesPaths?.length ? space.imagesPaths[space.imagesPaths.length - 1] : ''}
                alt={`Foto de ${space?.name}`}
                rounded
              />
            </div>
            { usersWithImages && usersWithImages.map((user, index) => 
            <div className="user-image" style={{right: `${-40+(index*-35)}%`, zIndex: usersWithImages?.length-1-index}}>
              <Image
                src={user?.imagesPaths?.length ? user.imagesPaths[user.imagesPaths.length - 1] : ''}
                alt={`Foto de ${user?.firstName} ${user?.lastName}`}
                rounded
              />
            </div>
            )}
          </div>

          <div className="space-options">
            

            <button type="button" onClick={eventsHandlers.handleShareClick} className="rounded-button">
              <FiShare2 size={30} color="#000" strokeWidth={1.4} />
            </button>

            <button type="button" onClick={() => eventsHandlers.handleMessageClick(space)} className="rounded-button">
              <FiMessageCircle size={30} color="#000" strokeWidth={1.5} />
            </button>
            
            <ShareButtons
              display={localStates.shareDisplay}
              url={String(window.location)}
              title={`Venha conhecer as ofertas da(o) ${space?.name} no aplicativo Locall`}
              size="2.5em"
            />
          
          </div>
        </div>

        <div className="space-info">
          <div className="space-text">
            <h3>{space?.name}</h3>

            <div className="users-names">
              <p>
                <span>por </span>
                {
                  users?.length
                    ? users.map((user, index) => `${user.firstName} ${user.lastName}${index === users.length - 1 ? '' : ', '}`)
                    : 'carregando...'
                }
              </p>
            </div>

            <div className="space-bios">
              <p>
                {
                  localStates.biosOpened
                    ? bios || ''
                    : bios?.substring(0, BIOS_MAX_LEN) || ''
                }

                <button type="button" onClick={eventsHandlers.handleBiosToggle}>
                  { localStates.biosOpened ? 'menos' : '...mais'}
                </button>
              </p>


              {
                localStates.biosOpened
                  ? (
                    <section className="space-details">
                      {space?.delivery?.homeDelivery && (
                        <div className="space-detail-item">
                          <FiTruck className="space-detail-item-icon" color="#000" size="18" />
                          <div className="space-detail-item-texts">
                          <p>
                            Entregamos em sua casa na
                            {space?.delivery?.homeDelivery?.daysOfWeek?.map((dayOfWeek, index) => (
                              <span>
                                <strong>{` ${daysPT[dayOfWeek]}`}</strong>
                                {index < space?.delivery?.homeDelivery.daysOfWeek.length - 2 && ', '}
                                {index === space?.delivery?.homeDelivery.daysOfWeek.length - 2 && ' e '}
                              </span>
                            ))}
                          </p>
                          {space?.delivery?.homeDelivery?.gratuity &&
                            <div className="space-detail-subitem">
                              <p>
                                Frete gratuito
                                {' '}
                                {space?.delivery?.homeDelivery?.gratuity?.daysOfWeek?.map((dayOfWeek, index) => (
                                  <span>
                                    <strong>{` ${daysPT[dayOfWeek]}`}</strong>
                                    {index < space?.delivery?.homeDelivery.gratuity.daysOfWeek.length - 2 && ', '}
                                    {index === space?.delivery?.homeDelivery.gratuity.daysOfWeek.length - 2 && ' e '}
                                  </span> 
                                ))}
                                { (space?.delivery?.homeDelivery?.gratuity?.daysOfWeek?.length 
                                &&  (space?.delivery?.homeDelivery?.gratuity?.kilometerRadius 
                                ||  space?.delivery?.homeDelivery?.gratuity?.minOrderValue) 
                                && ' ou ')
                                }
                                { space?.delivery?.homeDelivery?.gratuity?.kilometerRadius && 
                                <span>
                                 em distância de até
                                  <strong>{` ${space?.delivery?.homeDelivery?.gratuity?.kilometerRadius} km `}</strong> 
                                </span>
                                }  
                                {(space?.delivery?.homeDelivery?.gratuity?.kilometerRadius 
                                &&  space?.delivery?.homeDelivery?.gratuity?.minOrderValue) 
                                && 'ou '}
                                {space?.delivery?.homeDelivery?.gratuity?.minOrderValue
                                && 
                                <span>com pedido mínimo de  
                                <strong>{` ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(space?.delivery?.homeDelivery?.gratuity?.minOrderValue)}`}</strong>
                                </span>
                                }
                                </p>
                            </div>
                          }
                          </div>
                        </div>

                      )}

                      {space?.delivery?.grabAndGo && (
                        <div className="space-detail-item">
                          <FiTruck className="space-detail-item-icon" color="#000" size="18" />
                          <p>
                            Retire seu pedido aqui na
                            {space?.delivery?.grabAndGo.daysOfWeek.map((dayOfWeek, index) => (
                              <span key={index}>
                                <strong>{` ${daysPT[dayOfWeek]}`}</strong>
                                {index < space?.delivery?.grabAndGo.daysOfWeek.length - 2 && ', '}
                                {index === space?.delivery?.grabAndGo.daysOfWeek.length - 2 && ' e '}
                              </span>
                            ))}
                          </p>
                        </div>
                      )}

                      <div className="space-detail-item">
                        <FiDollarSign className="space-detail-item-icon" color="#000" size="18" />
                        <p>
                          Aceitamos pagamento por
                          {space?.payment.methods.map((method, index) => (
                            <span>
                              <strong>
                                {{
                                  credit_card: ' cartão de crédito',
                                  debit_card: ' cartão de débito',
                                  bank_transfer: ' transferência / pix',
                                  billet: ' boleto',
                                  cash: ' dinheiro',
                                }[method]}
                              </strong>
                              {index < space?.payment.methods.length - 2 && ', '}
                              {index === space?.payment.methods.length - 2 && ' e '}
                            </span>
                          ))}
                        </p>
                      </div>

                      <div className="space-detail-item">
                        <FiPhone className="space-detail-item-icon" color="#000" size="18" />
                        <p>
                          {' '}
                          { space?.whatsapp?.toString().replace(/^(\d{3})(\d{2})(\d)(\d{4})(\d{4})$/, '$1 ($2) $3 $4-$5')}
                        </p>
                      </div>

                      <div className="space-detail-item">
                        <FiGlobe className="space-detail-item-icon" color="#000" size="18" />
                        <p>{`locall.netlify.com/${space?.nickname}`}</p>
                      </div>
                    </section>
                  )
                  : <></>
              }
            </div>
          </div>
        </div>

        <div className="space-location">
          <FaMapMarker size={20} color="#CF5648" strokeWidth={1.2} />
          <p>
            {
              space?.addresses?.length
                ? `${space?.addresses?.[0]?.neighborhood}, ${space?.addresses?.[0]?.street}`.substring(0, ADDR_MAX_LEN)
                : 'carregando'
            }
            ...
          </p>
        </div>

        <button 
          type="button" 
          className="region-button" 
          onClick={() => eventsHandlers.handleRegionClick({
            lat: space?.addresses?.[0]?.lat,
            lng: space?.addresses?.[0]?.lng,
          })}>
          Conhecer a região
        </button>
      </section>
    </div>
  );
}
